// Interface to modernizr loaded seperately


	global.ua = navigator.userAgent.toLowerCase();
	global.isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");	

	global.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
	    // Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
	global.isFirefox = typeof InstallTrigger !== 'undefined';   // Firefox 1.0+
	global.isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
	    // At least Safari 3+: "[object HTMLElementConstructor]"
	global.isChrome = !!window.chrome && !isOpera;              // Chrome 1+
	global.isIE = /*@cc_on!@*/false || !!document.documentMode; // At least IE6

	global.isiPad = !!navigator.userAgent.match(/iPad/i);
	global.isiPhone =!!navigator.userAgent.match(/iPhone/i);
	global.isiPod = !!navigator.userAgent.match(/iPod/i);
	
	global.iswebOS = !!navigator.userAgent.match(/webOS/i);
	global.isblackBerry = !!navigator.userAgent.match(/BlackBerry/i);
	global.isIEMobile = !!navigator.userAgent.match(/IEMobile/i);
	global.isoperaMini = !!navigator.userAgent.match(/Opera Mini/i);


	
	global.canAutoPlay = (!(isiPad || isiPhone || isiPod || isAndroid || isIEMobile));
	
	console.log('Modernizr - autoplay: ' + canAutoPlay);

